import BossModel from "@/models/BossModel";
import Day from "@/models/Product/Discount/Day/Day";
import DiscountProductDetailComposition from "@/models/Product/Discount/DiscountProductDetailComposition";
import ChargeType from "@/models/ChargeType/ChargeType";
import Group from "@/models/Product/Discount/Group/Group";
import Type from "@/models/Product/Discount/Type/Type";
import Currency from "@/models/Currency/Currency";

export default class Discount extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/discount';

    /**
     *
     * @type {string}
     */
    static entity = 'productDiscount';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_price_extension_element_id: this.number(null).nullable(),
            apply_to_purchase: this.attr(null),
            currency_id: this.number(null).nullable(),
            product_discount_group_id: this.number(null).nullable(),
            product_discount_type_id: this.number(null).nullable(),
            is_visible_to_customer: this.boolean(null),
            charge_type_id: this.number(null).nullable(),
            apply_to_sale: this.boolean(null),
            charge_unit_id: this.number(null).nullable(),
            book_before_type: this.number(null),
            book_date_before: this.attr(null),
            book_days_before: this.number(null).nullable(),
            start: this.boolean(null),
            end_date_at: this.attr(null),
            adult: this.number(null).nullable(),
            child: this.number(null).nullable(),
            baby: this.number(null).nullable(),
            single_amount: this.number(null).nullable(),
            start_date_at: this.attr(null),
            x_night: this.number(null).nullable(),
            y_night: this.number(null).nullable(),
            max_night: this.number(null).nullable(),
            note: this.attr(null),
            sort_order: this.number(null).nullable(),
            is_active: this.boolean(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            byHistory: this.boolean(null),
            pax: this.hasMany(DiscountProductDetailComposition, 'product_discount_id'),
            days: this.hasMany(Day, 'product_discount_id'),
            chargeType: this.belongsTo(ChargeType, 'charge_type_id'),
            type: this.belongsTo(Type, 'product_discount_type_id'),
            group: this.belongsTo(Group, 'product_discount_group_id'),
            currency: this.belongsTo(Currency, 'currency_id'),
        }
    }
}
